// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3XYXc","errorLogs":"EditorFooter_errorLogs__2c8be"};